import * as React from "react"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import * as moment from "moment"
import DebtComponent from "./debt-component"
import { LoanWithDecomposition, Ppi, PpiYearLoan } from "../../model"
import * as actionCreators from "../../action-creators"
import { getLoansWithDecomposition, geteDcompositionWithLoans } from "../../domain/sfp/loan-domain"
import { getProfile, Profile } from "../../domain/sfp/user-domain"
import { ReducerState, MappedActionsProps } from "../../reducer"
import ScenarioService from '../../service/sfp/scenario-service';
import PPIService from '../../service/sfp/ppi-service';
import * as LoansService from '../../service/sfp/loans-service-2';
import './style.scss'
import DebtSimplifiedComponent from "./debt-simplified-component";
import Switch from "react-switch";
import { updateLocalAuthorityDebtMode } from "../../service/sfp/local-authorities-service-2"
import * as PpiDomain from "../../domain/sfp/ppi-domain"
import { LocalAuthorityDebtSimplifiedYearModel } from "../../model/local-authority-crd-year"

class Debt extends React.Component<InjectedProps, State> {
    private readonly years: number[]

    constructor(props: Readonly<InjectedProps>) {
        super(props)

        this.years = this.getYears()

        this.state = {
            viewMode: ViewMode.Debt,
            loading: true,
            loansWithDecomposition: [],
            decompositionWithloans: [],
            displayGraphic: false,
            displaySimulate: true,
            switchGraph: 'bar',
            displaySimulateRécupérable: true,
            displayDette: true,
            displayDetteSimuléeRécupérable: true,
            scenarii: {},
            ppi: [],
            services: [],
            loadingStr: '',
            loans: [],
            ppiYearLoans: []
        }
    }

    componentDidMount() {   
        this.initData(this.props);
        this.props.actions.setPageTitle('Dette')
        if (this.props.currentLocalAuthority) { 
            this._loadScenarii(this.props.currentLocalAuthority)            
            this.setState({
                viewMode: this.props.currentLocalAuthority.isDebtSimplified ? ViewMode.DebtSimplified : ViewMode.Debt
            });
        }
    }

    componentDidUpdate(prevProps, pervState) {
        const prev = prevProps.currentLocalAuthority;
        const curr = this.props.currentLocalAuthority;
        
        if (!curr) return;

        if (!prev || prev.id !== curr.id) {
            // Changement de collectivité ou première réception → on recharge tout
            this._loadScenarii(curr);
            this.setState({
                viewMode: curr.isDebtSimplified ? ViewMode.DebtSimplified : ViewMode.Debt
            });
        } else if (prev.isDebtSimplified !== curr.isDebtSimplified) {
            // Juste le switch → on met à jour le viewMode sans recharger
            this.setState({
                viewMode: curr.isDebtSimplified ? ViewMode.DebtSimplified : ViewMode.Debt
            });
        }
    }

    _loadScenarii(LA) {
        this.setState({ scenarii: null, ppi: null, services: null, loading: true, loadingStr: "Chargement des scenarii" }, () => {
            Promise.all([
                ScenarioService.findScenariiByLAId(LA.id)
                    .then(r => { this._resolveFindScenarii(r) })
                    .catch(r => { this._rejectFindScenarii(r) }),
                PPIService.findPPIByLAId(LA.id)
                    .then(r => { this._resolveFindPPI(r) })
                    .catch(r => { this._rejectFindPPI(r) }),
                LoansService.findLoans(this.props.currentLocalAuthority)
                    .then(r => this._resolveFindLoans(r))
                    .catch(r => { this._rejectFindLoans(r) }),
            ]).then(() => {
                this.setState({ loading: false })                
            });
        })
    }

    async _refreshPpi() {        
        if (!this.props.currentLocalAuthority) return;

        try {
            const ppi = await PPIService.findPPIByLAId(this.props.currentLocalAuthority.id);
            this.setState({ ppi }); // mets à jour le state
        } catch (error) {
            console.error("Erreur refresh PPI", error);
        }
    }
    async _refreshScenarii() {        
        if (!this.props.currentLocalAuthority) return;

        try {
            const ppi = await ScenarioService.findScenariiByLAId(this.props.currentLocalAuthority.id)
            .then(r => { this._resolveFindScenarii(r) })
        } catch (error) {
            console.error("Erreur refresh Scenarii", error);
        }
    }

    _resolveFindLoans(response) {
        this.setState({ loans: response })
    }

    _rejectFindLoans(error) {
        this._dispatchReceiveError(error);
    }

    _resolveFindPPI(ppi: Ppi) {
        this.setState(
            { ppi },
            () => {
                if (this.state.loansWithDecomposition) {
                    const ppiYearLoans = PpiDomain.getPpiYearLoans(this.state.loansWithDecomposition, ppi);
                    this.setState({
                        ppiYearLoans,
                    });                
                }
            }
        );
    }

    _rejectFindPPI(error) {        
        this.setState({ ppi: { investment_themes: [], years: [], expenses: [], revenues: [] }, loading: (this.state.services && this.state.scenarii && this.state.loans) ? false : true })
    }

    _resolveFindScenarii(response) {
        const scenarii = response
        const currentYear = parseInt(moment().format("YYYY"))

        // Regroupement des scénarios par année
        const grouped = new Map()
        grouped.set(currentYear + 1, [])
        grouped.set(currentYear, [])

        scenarii.forEach((scenario) => {
            if (!grouped.has(scenario.year)) {
                grouped.set(scenario.year, [])
            }
            grouped.get(scenario.year).push(scenario)
        })

        // Recherche du scénario validé pour l'année en cours
        const scenariosCurrentYear = grouped.get(currentYear) || []
        const senario = scenariosCurrentYear.find((s: any) => s.validated === true)

        this.setState({ scenarii: senario })
    }

    _rejectFindScenarii(error) {
        this._dispatchReceiveError(error);
    }

    _dispatchReceiveError(error) {
        this.props.actions.throwError(error);
    }

    componentWillReceiveProps(props: Readonly<InjectedProps>) {
        this.initData(props)
    }

    render() {
        if (this.state.loading) {
            return <div>Chargement...</div>;
        }
        const consulted = getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant;
        return (
            <span>
                <div className="field-switch">
                    <span className="button is-text">
                        <Switch
                            onChange={this.handleViewModeSwitch}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checked={this.state.viewMode === ViewMode.DebtSimplified}
                        />
                    </span>

                    <label>
                        {this.state.viewMode === ViewMode.DebtSimplified ? (
                            <strong>Mode dette simplifiée activé</strong>
                        ) : (
                            'Pour passer en mode dette simplifiée, veuillez cliquer sur le bouton'
                        )}
                    </label>
                </div>

                {this.renderContent(consulted)}
            </span>
        );
    }

    private handleViewModeSwitch = (checked: boolean) => {
        this.setState({
            viewMode: checked ? ViewMode.DebtSimplified : ViewMode.Debt
        });
        this.updateViewModeBdd(checked);
    };

    private updateViewModeBdd = (checked: boolean) => {
        updateLocalAuthorityDebtMode(this.props.currentLocalAuthority, checked)
        .then(() => {
            const updatedLocalAuthority = {
                ...this.props.currentLocalAuthority,
                isDebtSimplified: checked
            };
            this.props.actions.updateCurrentLocalAuthority(updatedLocalAuthority);
        })
        .catch(err => {
            // revert switch si erreur
            this.setState({
                viewMode: checked ? ViewMode.Debt : ViewMode.DebtSimplified
            });
        });
    }

    private _updateDebtSimplifiedYear = (year: number, payload: Partial<LocalAuthorityDebtSimplifiedYearModel>) => {
        const la = this.props.currentLocalAuthority;
        if (!la) return;

        const years = la.localAuthorityDebtSimplifiedYears ? [...la.localAuthorityDebtSimplifiedYears] : [];
        const existingIndex = years.findIndex((y: any) => y.year === year);
        if (existingIndex >= 0) {
            years[existingIndex] = { ...years[existingIndex], ...payload };
        } else {
            years.push({ year, ...payload } as any);
        }

        this.props.actions.updateCurrentLocalAuthority({
            ...la,
            localAuthorityDebtSimplifiedYears: years
        });
    }

    private renderContent(consulted: boolean) {                      
        if (!this.props.currentLocalAuthority) return null;  
        switch (this.state.viewMode) {
            case ViewMode.DebtSimplified:
                return (
                    <DebtSimplifiedComponent
                        localAuthority={this.props.currentLocalAuthority}
                        years={this.years}
                        ppiYearLoans={this.state.ppiYearLoans}
                        loading={this.state.loading}
                        loans={this.state.loans}
                        scenarii={this.state.scenarii}
                        ppi={this.state.ppi}
                        refreshPpi={this._refreshPpi.bind(this)}
                        refreshScenarii={this._refreshScenarii.bind(this)}
                        onDebtSimplifiedYearUpdate={this._updateDebtSimplifiedYear}
                    />
                );

            case ViewMode.Debt:
            default:
                return (
                    <DebtComponent
                        consulted={consulted}
                        displayGraphic={this.state.displayGraphic}
                        scenarii={this.state.scenarii}
                        ppi={this.state.ppi}
                        services={this.state.services}
                        loans={this.state.loans}
                        displaySimulate={this.state.displaySimulate}
                        displaySimulateRécupérable={this.state.displaySimulateRécupérable}
                        displayDette={this.state.displayDette}
                        displayDetteSimuléeRécupérable={
                            this.state.displayDetteSimuléeRécupérable
                        }
                        switchGraph={this.state.switchGraph}
                        loading={this.state.loading}
                        loansWithDecomposition={this.state.loansWithDecomposition}
                        decompositionWithloans={this.state.decompositionWithloans}
                        localAuthority={this.props.currentLocalAuthority}
                        onClickCloseButton={(e) => this.handleClickCloseButton(e)}
                        onClickSwitchButton={(e) => this.handleClickSwitchButton(e)}
                        onClickViewGraphic={(e) => this.handleClickViewGraphic(e)}
                        onSimulateChange={() => this.handleSimulateChange()}
                        ondetteChange={() => this.handleDetteChange()}
                        onDetteSimuléeRécupérableChange={() =>
                            this.handleDetteSimuléeRécupérableChange()
                        }
                        onSimulateRécupérableChange={() =>
                            this.handleSimulateRécupérableChange()
                        }
                        years={this.years}
                    />
                );
        }
    }

    private getYears(): number[] {
        const currentYear = (new Date()).getFullYear();
        const start = currentYear - 6;
        const end = currentYear + 22;
        const years: number[] = []

        for (let i = start; i < end; i++) years.push(i)

        return years
    }

    private initData(props: Readonly<InjectedProps>) {
        if (props.loadingCurrentLocalAuthority) return
        if (!props.currentLocalAuthority) return
        if (props.loadingCurrentLocalAuthorityLoans) return

        this.setState({
            // loading: false,
            loansWithDecomposition: getLoansWithDecomposition(props.currentLocalAuthorityLoans),
            decompositionWithloans: geteDcompositionWithLoans(props.currentLocalAuthorityLoans)
        })
    }

    private handleClickCloseButton(e: React.SyntheticEvent<Element>): void {
        e.preventDefault()
        this.setState({ displayGraphic: false })
    }

    private handleClickSwitchButton(e: React.SyntheticEvent<Element>): void {
        e.preventDefault()
        this.setState({ switchGraph: this.state.switchGraph == 'bar' ? 'pie' : 'bar' })
    }

    private handleClickViewGraphic(e: React.SyntheticEvent<Element>): void {
        e.preventDefault()
        this.setState({ displayGraphic: true })
    }

    private handleSimulateChange() {
        const displaySimulate = !this.state.displaySimulate
        this.setState({ displaySimulate })
    }

    private handleSimulateRécupérableChange() {
        const displaySimulateRécupérable = !this.state.displaySimulateRécupérable
        this.setState({ displaySimulateRécupérable })
    }

    private handleDetteChange() {
        const displayDette = !this.state.displayDette
        this.setState({ displayDette })
    }

    private handleDetteSimuléeRécupérableChange() {
        const displayDetteSimuléeRécupérable = !this.state.displayDetteSimuléeRécupérable
        this.setState({ displayDetteSimuléeRécupérable })
    }
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state
}

export default connect(mapStateToProps, mapDispatchToProps)(Debt)

export { default as LoanDetail, Context } from "./loan-detail"

export interface Props { }

export enum ViewMode {
    Debt = 'debt',
    DebtSimplified = 'debt_simplified'
}

interface State {
    viewMode: ViewMode,
    loading: boolean
    loansWithDecomposition: LoanWithDecomposition[]
    decompositionWithloans: LoanWithDecomposition[]
    displayGraphic: boolean
    displaySimulate: boolean
    displayDette: boolean
    displaySimulateRécupérable: boolean
    displayDetteSimuléeRécupérable: boolean
    switchGraph: string
    scenarii: any
    ppi: any
    services: any
    loadingStr: string
    loans: any
    ppiYearLoans: PpiYearLoan[]
}

type InjectedProps = MappedActionsProps &
    Props &
    ReducerState



// WEBPACK FOOTER //
// ./src/component/debt/index.tsx